export enum OrderSyncToPayPal {
  "SyncedSuccessfully" = 11,
  "SyncFailed" = 12,
  "Unsynced" = 10,
  "OtherPaymentMethods" = 0,
}
